const useDropdown = () => {
  const selects = [...document.querySelectorAll('[data-select-for]')]
  const dropdowns = [...document.querySelectorAll('[data-dropdown-for]')]
  if (!selects.length || !dropdowns.length) return;

  selects.forEach(select => {
    const name = select.getAttribute('data-select-for')
    const dropdown = document.querySelector(`[data-dropdown-for="${name}"]`)
    if (!dropdown) return;

    const input = select.querySelector('input')
    const dropdownItems = [...dropdown.querySelectorAll('[data-value]')]

    select.addEventListener('click', () => {
      dropdown.classList.toggle('is-dropped')
      dropdowns.forEach(item => {
        if (item !== dropdown) {
          item.classList.remove('is-dropped')
        }
      })
    })

    dropdownItems.forEach(item => {
      const value = item.getAttribute('data-value')

      item.addEventListener('click', () => {
        input.value = value
        item.classList.add('is-active')
        dropdownItems.forEach(other => {
          if (item === other) return
          other.classList.remove('is-active')
        })
      })
    })

    document.addEventListener('click', (e) => {
      const { target } = e
      if (target.getAttribute('data-dropdown-for') || target.closest('[data-dropdown-for]') || target.getAttribute('data-select-for') || target.closest('[data-select-for]')) return

      dropdowns.forEach(item => {
        item.classList.remove('is-dropped')
      })
    })
  })
}


export {
  useDropdown
}